import MdaeDateAutoComplete from "./component";
import { IAutocompleteOptions } from "devextreme-react/autocomplete";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeDateAutoCompleteProps extends IAutocompleteOptions {
  id: string;
}
export default MdaeDateAutoComplete;
